import {InjectionToken} from "@angular/core";

export const ROUTER_PATHS_TOKEN = new InjectionToken('router paths token ', {
  factory() {
    return {}
  },
  providedIn: 'root'
});
